import React from "react"

const SearchIcon = () => {
  return (
    <svg viewBox="0 0 1414 1519" version="1.1" xmlns="http://www.w3.org/2000/svg" style={{ fillRule: "evenodd", clipRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: "1.5" }}>
      <g transform="matrix(1,0,0,1,-1206.57,-1347.06)">
        <circle cx="1813.17" cy="1953.66" r="523.269" style={{ fill: "none", stroke: "#949494", strokeWidth: "166.67px" }} />
      </g>
      <g transform="matrix(1,0,0,1,-1419.84,-939.259)">
        <path d="M2373.49,1943.19L2749.74,2373.95" style={{ fill: "none", stroke: "#949494", strokeWidth: "166.67px" }} />
      </g>
    </svg>
  )
}

export default SearchIcon